import "./modal.css"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from "react-i18next";

function IraModal({showIra, hideIraModal}) {

    const {t} = useTranslation()

    return (
        <>
            <Modal show={showIra} onHide={() => hideIraModal()}>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>{t('modals.ira_modal.ira')}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => hideIraModal()}>
                        {t('modals.ira_modal.close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default IraModal;